module.exports = __webpack_public_path__ + "img/gray-dot-4x4.fb13a588.svg";